import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import nl from 'vuetify/src/locale/nl.ts'
import en from 'vuetify/src/locale/en.ts'

Vue.use(Vuetify, {
  options: {
    customProperties: true,
  },
  iconfont: 'fa',
  theme: {
    primary: '#007ba3',
    secondary: '#8E4C75',
    accent: '#599003',
    error: '#FF5252',
    info: '#2196F3',
    success: '#5C9000',
    warning: '#FFC107',
    light: '#F5F5F5',
    lower: '#74af27',
    extra: '#7CAFC2',
  },
  lang: {
    locales: { nl, en },
    current: 'nl',
  },
})
